const defaultLayouts = {
  lg: [
    {
      h: 61,
      w: 6,
      x: 0,
      y: 0,
      componentList: ['TVChartContainer', 'DepthChart'],
      title: 'exchange.chart',
    },
    {
      h: 32,
      w: 10,
      x: 0,
      y: 61,
      componentList: ['OpenOrders', 'OrderHistory', 'MyTradeHistory', 'Portfolio'],
    },
    {
      h: 61,
      w: 2,
      x: 6,
      y: 0,
      componentList: ['OrderBook'],
      title: 'exchange.orderBook',
      hasHeading: true,
    },
    {
      h: 61,
      w: 2,
      x: 8,
      y: 0,
      componentList: ['CreateOrder'],
      title: 'exchange.orderBook',
    },
  ],
  md: [
    {
      h: 50,
      w: 12,
      x: 0,
      y: 0,
      componentList: ['TVChartContainer', 'DepthChart'],
      title: 'exchange.chart',
    },
    {
      h: 40,
      w: 12,
      x: 0,
      y: 91,
      componentList: ['OpenOrders', 'OrderHistory', 'MyTradeHistory', 'Portfolio'],
    },
    {
      h: 41,
      w: 6,
      x: 0,
      y: 50,
      componentList: ['OrderBook'],
      title: 'exchange.orderBook',
      hasHeading: true,
    },
    {
      h: 41,
      w: 6,
      x: 6,
      y: 50,
      componentList: ['CreateOrder'],
    },
  ],
  sm: [
    {
      h: 33,
      w: 1,
      x: 0,
      y: 0,
      componentList: ['TVChartContainer', 'DepthChart'],
      isDraggable: false,
      isResizable: false,
    },
    {
      h: 33,
      w: 1,
      x: 0,
      y: 33,
      componentList: ['OrderBook', 'OrderHistory', 'MyTradeHistory', 'OpenOrders', 'Portfolio'],
      isDraggable: false,
      isResizable: false,
    },
    {
      h: 71,
      w: 1,
      x: 0,
      y: 66,
      componentList: ['CreateOrder'],
      isDraggable: false,
      isResizable: false,
    },
  ],
};

export default defaultLayouts;
